/**
 * Return a SHA-256 digest.
 * @param {string} plain
 * @returns {Promise<ArrayBuffer>}
 */
const sha256Digest = async (plain: string): Promise<ArrayBuffer> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest('SHA-256', data);
};

/**
 * Return a base64 URL safe encoded string.
 * @param {ArrayBuffer} a
 * @returns {string}
 */
const base64URLEncode = (a: ArrayBuffer): string => {
  let jsonKey = '';
  new Uint8Array(a).forEach(function (byte: number) {
    jsonKey += String.fromCharCode(byte);
  });
  return btoa(jsonKey)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

/**
 * Generate a Proof of Key Code Exchange (PKCE) code challenge from a code
 * verifier.
 * @param {string} v
 * @returns {Promise<string>}
 */
export const codeChallengeFromVerifier = async (v: string): Promise<string> => {
  const hashed = await sha256Digest(v);
  const base64encoded = base64URLEncode(hashed);
  return base64encoded;
};

/**
 * Convert a number to its hexademical representation.
 * @param {number} dec
 * @returns {string}
 */
const dec2hex = (dec: number): string => dec.toString(16).padStart(2, '0');

/**
 * Return a hex encoded string of 32 octets of randomness.
 * @returns {string}
 */
export const randomHex = (): string => {
  const buf = new Uint8Array(32);
  window.crypto.getRandomValues(buf);
  return Array.from(buf, dec2hex).join('');
};

export type ConcedoToken = {
  iss: string;
  sub: string;
  aud: string;
  exp: number;
  iat: number;
  at_hash: string;
  c_hash: string;
  email: string;
  email_verifier: boolean;
  concedo: {
    id: string;
  };
  concedo_id: string;
};
